import React, { useEffect } from 'react'
import Header from '../../../headerone/Main'
import Bredcom from '../../../Bredcom/Main'
import LicenseIdUpdateApplication from '../../menforms/form/LicenseIDUpdate'
// import Mayor from '../../menhome/Mayor'
// import Second from '../../menhome/Client'

function Main() {

  useEffect(() => {
    document.getElementById("title").innerHTML="License/ID Update Form || Forms";
  }, [])

  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
          <Bredcom 
            subtitle="Forms"
            title="License/ID Update Form"
            subtitledown="License/ID Update Form"
           />
            <LicenseIdUpdateApplication/>
            {/* <Mayor/>
            <Second/> */}
        </div>
    </>
  )
}

export default Main